export const VERIFICATION_CODE_LENGTH = 6;
export const DEFAULT_ERROR_MESSAGE =
  'Something went wrong. Please try again later. ';
export const CUSTOMER_SUPPORT_URL = 'mailto:cs@fanaticscollect.com';
